import { Directive, EmbeddedViewRef, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { SettingsService } from "../services/settings.service";

type Module = Exclude<keyof SettingsService["additionalModules"], "__typename">;

@Directive({ selector: "[appLicensed]" })
export class LicensedDirective implements OnInit {
  private module: Module;
  private viewRef: EmbeddedViewRef<any>;

  @Input()
  set appLicensed(module: Module | "") {
    this.module = module !== "" ? module : undefined;
    this.init();
  }

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly settings: SettingsService
  ) {}

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.viewRef?.destroy();
    this.viewRef = null;

    const isPermitted = this.settings.isLicensed && this.settings.hasModule(this.module);
    if (isPermitted) {
      this.viewRef = this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
